import { c as _c } from "react/compiler-runtime";
import { getPlaceLines, type GoogleLocationResult } from '@repo/geolocation';
import { MapPin } from '@repo/ui/icons';

/** A Google location search result: its name over its full address, wrapped rather than cut off. */
export const GoogleLocationRow = t0 => {
  const $ = _c(13);
  const {
    hint,
    place
  } = t0;
  let t1;
  if ($[0] !== place) {
    t1 = getPlaceLines(place);
    $[0] = place;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    address,
    title
  } = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MapPin className="mt-0.5 size-4 shrink-0 text-muted-foreground" data-sentry-element="MapPin" data-sentry-source-file="google-location-row.tsx" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== title) {
    t3 = <span className="block font-medium">{title}</span>;
    $[3] = title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== address) {
    t4 = address && <span className="block text-xs text-muted-foreground">{address}</span>;
    $[5] = address;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== hint) {
    t5 = hint && <span className="block text-xs text-muted-foreground">{hint}</span>;
    $[7] = hint;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = <div className="flex min-w-0 flex-1 items-start gap-2" data-sentry-component="GoogleLocationRow" data-sentry-source-file="google-location-row.tsx">{t2}<div className="min-w-0 flex-1 wrap-break-word">{t3}{t4}{t5}</div></div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};